import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["memo"]
  static values = { updateUrl: String }

  connect() {
    console.log("Memo controller connected")
  }

  // フォーカスアウト時の保存
  saveMemoOnBlur() {
    this.saveMemo()
  }

  // PDF出力前の保存（保険として）
  saveMemoBeforePdf(event) {
    event.preventDefault()
    const pdfUrl = event.target.href
    
    // メモのtextareaを探して値を取得
    const memoTextarea = document.querySelector('[data-memo-target="memo"]')
    const memo = memoTextarea ? memoTextarea.value : ''
    
    this.saveMemoValue(memo).then(() => {
      // 保存完了後にPDF出力
      window.open(pdfUrl, '_blank')
    }).catch(() => {
      // 保存に失敗してもPDF出力は実行
      window.open(pdfUrl, '_blank')
    })
  }

  saveMemo() {
    const memo = this.memoTarget.value
    return this.saveMemoValue(memo)
  }

  saveMemoValue(memo) {
    const csrfToken = document.querySelector('[name="csrf-token"]').content

    return fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ survey: { memo: memo } })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'success') {
        console.log('メモが保存されました')
        this.showSaveIndicator()
      } else {
        console.error('メモの保存に失敗しました:', data.message)
      }
    })
    .catch(error => {
      console.error('メモの保存でエラーが発生しました:', error)
    })
  }

  // 保存完了の視覚的フィードバック
  showSaveIndicator() {
    // 既存の保存インジケーターがあれば削除
    const existingIndicator = document.querySelector('.memo-save-indicator')
    if (existingIndicator) {
      existingIndicator.remove()
    }

    // 保存完了メッセージを表示
    const indicator = document.createElement('div')
    indicator.className = 'memo-save-indicator fixed top-4 right-4 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50'
    indicator.textContent = '保存しました'
    document.body.appendChild(indicator)

    // 2秒後に自動で削除
    setTimeout(() => {
      if (indicator.parentNode) {
        indicator.remove()
      }
    }, 2000)
  }
}
